import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=e8be0d3c&scoped=true&"
import script from "./InsightCard.vue?vue&type=script&lang=js&"
export * from "./InsightCard.vue?vue&type=script&lang=js&"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=e8be0d3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8be0d3c",
  null
  
)

export default component.exports